export type AuthFailureKind =
  | 'cancelled'
  | 'popupBlocked'
  | 'interactionRequired'
  | 'silentExpected'
  | 'unexpected';

const POPUP_BLOCKED_CODES = new Set(['popup_window_error', 'empty_window_error']);
const CANCELLED_CODES = new Set(['user_cancelled', 'user_canceled']);
const INTERACTION_REQUIRED_CODES = new Set([
  'interaction_required',
  'login_required',
  'consent_required'
]);
const EXPECTED_SILENT_CODES = new Set([
  'monitor_window_timeout',
  'no_account_error',
  'silent_sso_error',
  'block_iframe_reload',
  'iframe_closed_prematurely'
]);

function errorCode(error: unknown): string {
  if (!error || typeof error !== 'object') return '';
  const candidate = error as { errorCode?: unknown; code?: unknown };
  const value = candidate.errorCode ?? candidate.code;
  return typeof value === 'string' ? value.toLowerCase() : '';
}

export function classifyAuthError(error: unknown): AuthFailureKind {
  const code = errorCode(error);
  if (CANCELLED_CODES.has(code)) return 'cancelled';
  if (POPUP_BLOCKED_CODES.has(code)) return 'popupBlocked';
  if (INTERACTION_REQUIRED_CODES.has(code)) return 'interactionRequired';
  if (EXPECTED_SILENT_CODES.has(code)) return 'silentExpected';
  return 'unexpected';
}
